import React from "react";
import Header from "../components/generalComponents/Header";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import Favorites from "../components/favorites/Favorites"

export default function FavoritesView() {
  return (
    <div className="pageWrapper">
      <Header title="Favorieten" needsLocation="Yes" />
      <div className="contentWrapper fadeInDelayed">
        <Favorites />
      </div>
      <BottomNavBar />
    </div>
  );
}
